import { render, staticRenderFns } from "./Opmerking.vue?vue&type=template&id=a0e7da8a&scoped=true"
import script from "./Opmerking.vue?vue&type=script&lang=js"
export * from "./Opmerking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e7da8a",
  null
  
)

export default component.exports